import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserGroups } from "../../library/allauth";

export default function AdminGuard({ children }) {
  const [checking, setChecking] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    getUserGroups()
      .then((res) => {
        if (
          res.status === 200 &&
          (res.data.groups.includes("xroadz_admin") ||
            res.data.groups.includes("customer_admin"))
        ) {
          setIsAdmin(true);
        } else {
          navigate("/home");
        }
      })
      .catch(() => navigate("/home"))
      .finally(() => setChecking(false));
  }, [navigate]);

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <p className="text-gray-500 text-sm">Checking access...</p>
      </div>
    );
  }

  if (!isAdmin) return null;

  return <>{children}</>;
}